import React, { Component } from "react";
import {withNamespaces} from "react-i18next";

class ExhibitionScenarioForm extends Component {

    state = {
        form: {
            id: null,
            label: '',
            scenarioKey: '',
            description: ''
        }
    }

    loading = true;

    componentDidMount() {
        const { data } = this.props;
        if(data) {
            this.setState({
                ...this.state,
                form: {
                    id: data.id,
                    label: data.label,
                    scenarioKey: data.scenarioKey,
                    description: data.description
                }
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { submit } = this.props;
        submit(this.state.form);
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="label"
                            value={this.state.form.label}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="col-form-label">{t('scenario-key')}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="scenarioKey"
                            value={this.state.form.scenarioKey}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="col-form-label">{t('description')}</label>
                        <textarea
                            className="form-control"
                            name="description"
                            value={this.state.form.description}
                            onChange={this.handleOnChangeInput}
                        />
                    </div>

                    <div className="form-group float-right">
                        { this.state.form.id ? (
                            <button type="submit" className={"btn btn-primary" }>
                                <i className="fas fa-edit"> </i> {t('edit')}
                            </button>
                        ) : (
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('create')}
                            </button>
                        ) }
                    </div>
                </form>
            </div>
        )
    }
}
export default withNamespaces()(ExhibitionScenarioForm);